import { useEffect, useRef, useState } from 'preact/hooks';

export const useTimer = (value: number | undefined, onEnd?: () => void): number => {
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  const [timeLeft, setTimeLeft] = useState<number | null>(
    value ? Math.max(0, value - Date.now()) : null
  );

  useEffect(() => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }

    if (!value) return;

    if (!!value && timeLeft !== null && timeLeft <= 0) {
      onEnd?.();
      return;
    }

    intervalRef.current = setInterval(() => {
      const newTimeLeft = Math.max(0, value - Date.now());

      if (newTimeLeft <= 0) {
        if (intervalRef.current) clearInterval(intervalRef.current);
        setTimeLeft(0);

        onEnd?.();
      } else {
        setTimeLeft(newTimeLeft);
      }
    }, 1000);

    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  return timeLeft ?? 0;
};
